import UserService from "../UserService";
import { ActorService } from "../fhir/ActorService";
import { AppointmentService } from "../fhir/AppointmentService";
import { DeviceService } from "../fhir/DeviceService";
import { FhirHttpClient } from "../fhir/FhirClient";
import { LocationService } from "../fhir/LocationService";
import { PatientService } from "../fhir/PatientService";
import { PractitionerService } from "../fhir/PractitionerService";
import { ScheduleService } from "../fhir/ScheduleService";
import { SlotService } from "../fhir/SlotService";
import { ActorCalendarService } from "./ActorCalendarService";
import { ActorDirectoryService } from "./ActorDirectoryService";
import { AppointmentPlanningService } from "./AppointmentPlanningService";
import { CalendarService } from "./CalendarService";
import { IdentityResolutionService } from "./IdentityResolutionService";
import { ScheduleDirectoryService } from "./ScheduleDirectoryService";
import { UserSchedulesService } from "./UserSchedulesService";

export interface SchedulingServices {
  actorCalendarService: ActorCalendarService;
  actorDirectoryService: ActorDirectoryService;
  actorService: ActorService;
  appointmentPlanningService: AppointmentPlanningService;
  calendarService: CalendarService;
  scheduleDirectoryService: ScheduleDirectoryService;
  userSchedulesService: UserSchedulesService;
}

export function createSchedulingServices(): SchedulingServices {
  const client = new FhirHttpClient(
    process.env.REACT_APP_FHIR_URL ?? "",
    UserService.getValidToken,
  );
  const patientService = new PatientService(client);
  const practitionerService = new PractitionerService(client);
  const locationService = new LocationService(client);
  const deviceService = new DeviceService(client);
  const scheduleService = new ScheduleService(client);
  const slotService = new SlotService(client);
  const appointmentService = new AppointmentService(client);
  const identityResolutionService = new IdentityResolutionService(
    patientService,
    practitionerService,
  );
  const actorCalendarService = new ActorCalendarService(scheduleService);

  return {
    actorCalendarService,
    actorDirectoryService: new ActorDirectoryService(
      patientService,
      practitionerService,
      locationService,
      deviceService,
    ),
    actorService: new ActorService(client),
    appointmentPlanningService: new AppointmentPlanningService(
      scheduleService,
      slotService,
      appointmentService,
    ),
    calendarService: new CalendarService(slotService, appointmentService),
    scheduleDirectoryService: new ScheduleDirectoryService(scheduleService),
    userSchedulesService: new UserSchedulesService(
      identityResolutionService,
      actorCalendarService,
    ),
  };
}
